__turbopack_context__.v({
  "banner": "CookieConsent-module__Ystraa__banner",
  "button": "CookieConsent-module__Ystraa__button",
  "buttons": "CookieConsent-module__Ystraa__buttons",
  "checkmark": "CookieConsent-module__Ystraa__checkmark",
  "container": "CookieConsent-module__Ystraa__container",
  "customCheckbox": "CookieConsent-module__Ystraa__customCheckbox",
  "landingPageModalOffset": "CookieConsent-module__Ystraa__landingPageModalOffset",
  "landingPageOffset": "CookieConsent-module__Ystraa__landingPageOffset",
  "modal": "CookieConsent-module__Ystraa__modal",
  "modalButtons": "CookieConsent-module__Ystraa__modalButtons",
  "modalContent": "CookieConsent-module__Ystraa__modalContent",
  "modalOverlay": "CookieConsent-module__Ystraa__modalOverlay",
  "modalTitle": "CookieConsent-module__Ystraa__modalTitle",
  "option": "CookieConsent-module__Ystraa__option",
  "optionDescription": "CookieConsent-module__Ystraa__optionDescription",
  "optionHeader": "CookieConsent-module__Ystraa__optionHeader",
  "preferencesActive": "CookieConsent-module__Ystraa__preferencesActive",
  "preferencesbutton": "CookieConsent-module__Ystraa__preferencesbutton",
  "saveButton": "CookieConsent-module__Ystraa__saveButton",
  "settingsButton": "CookieConsent-module__Ystraa__settingsButton",
  "text": "CookieConsent-module__Ystraa__text",
});
